// extracted by mini-css-extract-plugin
module.exports = {"navBar":"Style_navBar__EH1Z9","navOptions":"Style_navOptions__5ZQYw","CircleBtn":"Style_CircleBtn__HfIm8","active":"Style_active__cTdjK","OFFBtn":"Style_OFFBtn__2N36A"};